import { Component, OnDestroy, OnInit } from '@angular/core';
import { Currency } from '@df/interfaces';
import {
    EXERCISE_CALCULATION,
    EXERCISE_LOGIC,
    EXERCISE_MAGIC_BOX,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_SEQUENCE,
    EXERCISE_TASK,
    EXERCISE_INSERT
} from '@app/app.constants';
import { TaskService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { Subject } from 'rxjs/internal/Subject';
import { declensionOfNumerals } from '@app/_utils/helpers';
import { MainAnalyticsService } from '@profile/services/main_analytics.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-profile-results-exercises',
    templateUrl: './profile-results-exercises.component.html',
    styleUrls: ['./profile-results-exercises.component.scss']
})
export class ProfileResultsExercisesComponent implements OnInit, OnDestroy {
    currency: Currency;
    responseResult: any = null;
    logic: string = EXERCISE_LOGIC;
    calculation: string = EXERCISE_CALCULATION;
    magic_box: string = EXERCISE_MAGIC_BOX;
    task: string = EXERCISE_TASK;
    sequence: string = EXERCISE_SEQUENCE;
    puzzle_task: string = EXERCISE_PUZZLE_TASK;
    puzzle_example: string = EXERCISE_PUZZLE_EXAMPLE;
    insert: string = EXERCISE_INSERT;
    toggleStarModal = false;
    starData = {
        type_achievement: {
            star: '',
            title: ''
        },
        explanation: '',
        exercises_results: []
    };
    description: string;
    private destroy$: Subject<boolean> = new Subject<boolean>();
    routerEventSubscription: any;

    constructor(
        private taskService: TaskService,
        private mainAnalyticsService: MainAnalyticsService,
        private handlerService: HandlerService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        const lessonId = this.activatedRoute.snapshot.params['lesson_id'];
        if (lessonId) {
            localStorage.setItem('currentLessonId', `${lessonId}`);
            this.getLessonCardsResults(lessonId);
            // this.createRequestCashes(lessonId);
        }

        this.subscribeChangeUrl();
    }

    ngOnDestroy(): void {
        this.routerEventSubscription.unsubscribe();
        this.destroy$.next(true);
    }

    // private createRequestCashes(currentLessonId: number): void {
    //     const lessonsId = JSON.parse(localStorage.getItem('LESSONS_IDs'));
    //     const profile = JSON.parse(localStorage.getItem('profile'));
    //     const lessons = [];

    //     if (lessonsId.length) {
    //         const currentIndex = lessonsId.indexOf(currentLessonId);
    //         const prevLessonId = lessonsId[currentIndex - 1];
    //         const nextLessonId = lessonsId[currentIndex + 1];
    //         if (prevLessonId) {
    //             lessons.push(prevLessonId);
    //         }
    //         if (nextLessonId) {
    //             lessons.push(nextLessonId);
    //         }

    //         lessons.forEach(lessonId => {
    //             this.mainAnalyticsService
    //                 .getLessonCardsResults(lessonId, profile.user.id)
    //                 .subscribe(resp => this.handlerService.checkErrors(resp));
    //         });
    //     }
    // }

    private subscribeChangeUrl(): void {
        this.routerEventSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.url.split('/').pop() === 'exercises') {
                    const lessonId = Number(event.url.replace(/[^0-9]/g, ''));
                    this.responseResult = null;
                    if (lessonId) {
                        localStorage.setItem('currentLessonId', `${lessonId}`);
                        this.getLessonCardsResults(lessonId);
                        // this.createRequestCashes(lessonId);
                    }
                }
            }
        });
    }

    private getLessonCardsResults(lessonId) {
        const profile = JSON.parse(localStorage.getItem('profile'));
        this.mainAnalyticsService.getLessonCardsResults(lessonId, profile.user.id).subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.error) {
                this.responseResult = resp.data;
                this.currency = resp.data.currency;
            }
        });
    }

    getCardStyle(format) {
        switch (format) {
            case 'A5':
                return 'box-card__a5';
            case 'A6':
                return 'box-card__a6';
            case 'A7':
                return 'box-card__a7';
            case 'A3':
                return 'box-card__1_6';
        }
    }

    getMoneyAmount(instAmount) {
        const amount = parseFloat(instAmount);
        const kairos = true;
        let cur_str = declensionOfNumerals(amount, this.currency, kairos);
        if (this.currency) {
            cur_str = declensionOfNumerals(amount, this.currency);
        }
        if (amount === 0) {
            return '';
        } else {
            return '' + amount + ' ' + cur_str;
        }
    }

    getTaskSpacingStyle(i) {
        return i > 0 ? '' : 'exercise-spacing';
    }

    getMagicBoxObject(string) {
        return JSON.parse(string);
    }

    getMagicBoxCellRight(exercise, row_index, elem_index) {
        return this.getMagicBoxObject(exercise.exercise_correct_answers[0].shortAnswer)[row_index][elem_index];
    }

    getMagicBoxCellWrong(exercise, row_index, elem_index) {
        return this.getMagicBoxObject(exercise.shortAnswer)[row_index][elem_index];
    }

    compareMagicBoxAnswers(exercise, row_index: number, elem_index: number) {
        if (
            this.getMagicBoxObject(exercise.shortAnswer)[row_index][elem_index] ===
            this.getMagicBoxObject(exercise.exercise_correct_answers[0].shortAnswer)[row_index][elem_index]
        ) {
            return true;
        }
        return false;
    }

    getMagicBoxTdStyle(elem, exercise, row_index, elem_index) {
        if (elem == null) {
            if (this.compareMagicBoxAnswers(exercise, row_index, elem_index)) {
                return 'magic-box-border-right';
            }
            return 'magic-box-border-wrong';
        }
        return '';
    }

    convertSecondToMinute(card: any) {
        const cardDuration = this.taskService.converSecondsToMinuteString(card.duration);
        return cardDuration;
    }

    backOnLesson(): void {
        const lessonId = this.activatedRoute.snapshot.params['lesson_id'];
        this.router.navigate([`/profile/results/lessons/${lessonId}`]).then();
    }

    starModal() {
        this.toggleStarModal = false;
    }

    showStarModal(star: any) {
        this.starData = {
            type_achievement: {
                star: star.type_achievement.star,
                title: star.type_achievement.title
            },
            explanation: star.explanation,
            exercises_results: star.exercises_results
        };
        this.toggleStarModal = true;
    }
}
